import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MyProfileService } from "../myprofile.service"
import { Router } from '@angular/router';
import { AppRoute } from "../../../shared/app.routes";
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService, ValidationService } from "../../../shared/services/service.index"

import { confirmPasswordValidator } from '../../../shared/services/validation.service';
import { FuseAlertService } from '@fuse/components/alert';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  frmChangePassword: FormGroup;
  isSubmitBtnDisabled: boolean = false;
  apiResponseErrorMessage: string=null;
  notificationService: NotificationService;
  // Private
  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private myProfileService: MyProfileService,
    private snb: MatSnackBar,
    private spinner: NgxSpinnerService,
    public fuseAlertService: FuseAlertService,
  ) {
    this.notificationService = new NotificationService(snb);
    // Set the private defaults
    this.unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  ngOnInit(): void {

    this.frmChangePassword = this.formBuilder.group({
      currentPassword: ['', [Validators.required/*, ValidationService.passwordValidator*/]],
      newPassword: ['', [Validators.required, ValidationService.passwordValidator]],
      confirmPassword: ['', [Validators.required, confirmPasswordValidator]],
    });

    // Update the validity of the 'passwordConfirm' field
    // when the 'password' field changes
    this.frmChangePassword.get('newPassword').valueChanges
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(() => {
        this.frmChangePassword.get('confirmPassword').updateValueAndValidity();
      });

  }

  onSubmit() {
    this.isSubmitBtnDisabled = true;
    this.apiResponseErrorMessage = null;
    let model = {
      currentPassword: this.frmChangePassword.controls.currentPassword.value,
      newPassword: this.frmChangePassword.controls.newPassword.value,
      confirmPassword: this.frmChangePassword.controls.confirmPassword.value
    };

    this.spinner.show();
    this.myProfileService.changePassword(model).subscribe(result => {
      this.spinner.hide();
      this.isSubmitBtnDisabled = false;
      if (result.status === 1) {
        //this.notificationService.showNotification(result.message);
        this.fuseAlertService.show(result.message, result.status);
        this.router.navigate([AppRoute.dashboard]);
      }
      else if (result.status === 2) {
	      //this.apiResponseErrorMessage = result.message;
        this.fuseAlertService.show(result.message, result.status);
      }
      else if (result.status === 3) {
	      //this.apiResponseErrorMessage = result.message;
        this.fuseAlertService.show(result.message, result.status);
      }
      else if (result.status === 0) {
	      this.fuseAlertService.show(result.message, result.status);
      }
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }

}



